import StrategyService from '@/views/strategy/api'
import { filterUnitysCheck, includeAttributesInBlocks } from './helpers'
import { difference } from 'lodash'

const strategyService = new StrategyService()

export default {
    namespaced: true,
    state: {
        loading: true,
        onepage: [],
        unitys: [],
        blocks: [],
        horizons: [],
        objectives: [],
        objectivesLinked: [],
    },
    getters: {
        getOnepage(state) {
            return state.onepage
        },
        getBlock(state) {
            return function (id) {
                return state.blocks.find((block) => {
                    return block.id == id
                })
            }
        },
        isThereAnyBlockSet(state) {
            return !!state.blocks.length
        },
    },
    mutations: {
        SET_LOADING(state, data) {
            state.loading = data
        },
        SET_ONEPAGE_ALL(state, data) {
            state.onepage = data
        },
        UPDATE_ONEPAGE_ALL(state, data) {
            state.onepage = data
        },
        UPDATE_ONEPAGE_DATE(state, data) {
            Object.entries(data).forEach(([key, value]) => {
                state.onepage[key] = value
            })
        },
        SET_UNITYS_ALL(state, data) {
            state.unitys = data
        },
        SET_BLOCK(state, data) {
            state.blocks.forEach((block) => {
                if (data.id === block.id) {
                    return (block.attributes = data.attributes)
                }
            })
        },
        SET_BLOCKS_ALL(state, data) {
            state.blocks = data
        },
        SET_HORIZONS(state, data) {
            state.horizons = data
        },
        UPDATE_HORIZONS(state, data) {
            state.horizons = data
        },
        SET_OBJECTIVES(state, data) {
            state.objectives = data
        },
        SET_OBJECTIVE_ID(state, { id, data }) {
            const { key_results } = data
            const objective = state.objectives.find((ob) => ob.id === id)
            objective.key_results = key_results
        },
        SET_OBJECTIVES_LINKED(state, data) {
            state.objectivesLinked = data
        },
    },
    actions: {
        loadOnepage({ commit }) {
            return strategyService
                .get_onepage_all()
                .then(({ data }) => {
                    commit('SET_ONEPAGE_ALL', data)
                    return data
                })
                .catch((err) => console.log(err))
        },
        updateOnepage({ commit }, { id, body }) {
            return new Promise((res, rej) => {
                Object.keys(body).forEach((key) => {
                    body[key] == null && delete body[key]
                })
                strategyService
                    .put_onepage_all(id, { ...body })
                    .then(({ data }) => {
                        commit('UPDATE_ONEPAGE_ALL', data)
                        res(data)
                    })
                    .catch((err) => {
                        console.log(err)
                        rej(false)
                    })
            })
        },
        updateOnepageDate({ commit }, data) {
            commit('UPDATE_ONEPAGE_DATE', data)
            return data
        },
        loadUnitysAll({ commit }) {
            strategyService
                .get_sections_all()
                .then(({ data }) => {
                    commit('SET_UNITYS_ALL', data)
                })
                .catch((err) => console.log(err))
        },
        loadUnitysAndBlocks({ state, commit }, { id, data }) {
            return strategyService
                .get_onepage_search(id, data)
                .then(({ data }) => {
                    if (data.sections.length !== 0) {
                        const sections = data.sections.map((section) => {
                            return { ...section, value: true }
                        })
                        state.unitys.forEach(async (unity) => {
                            const validation = await filterUnitysCheck(unity.id, sections)
                            if (!validation) {
                                sections.push({
                                    ...unity,
                                    value: false,
                                })
                            }
                        })
                        commit('SET_UNITYS_ALL', sections)
                    }
                    const { blocks, attributes } = data
                    return { blocks, attributes }
                })
                .then(async ({ blocks, attributes }) => {
                    const blocksAndAttributes = await includeAttributesInBlocks(blocks, attributes)
                    commit('SET_BLOCKS_ALL', blocksAndAttributes)
                    return blocksAndAttributes
                })
                .catch((err) => console.log(err))
                .finally(() => commit('SET_LOADING', false))
        },
        updateUnity({ state, commit }, { data, idsUnitys }) {
            commit('SET_UNITYS_ALL', data)
            strategyService.put_unity(state.onepage.id, { section_id: idsUnitys }).catch((err) => console.log(err))
        },
        updateBlock({ state, commit }, data) {
            commit('SET_BLOCKS_ALL', data[0])
            strategyService
                .put_block(state.onepage.id, {
                    block_one_page_id: data[1].pivot.id,
                })
                .catch((err) => console.log(err))
        },
        updateBlockAttributes({ commit }, data) {
            commit('SET_BLOCK', data)
        },
        loadHorizons({ commit }, id) {
            return strategyService
                .getOnePageHorizons(id)
                .then(({ data }) => {
                    commit('SET_HORIZONS', data)
                    return data
                })
                .catch((err) => console.log(err))
        },
        updateHorizons({ commit }, data) {
            strategyService
                .updateHorizons(data[0], data[1])
                .then(({ data }) => {
                    commit('SET_HORIZONS', data)
                })
                .catch((err) => console.log(err))
        },
        getObjectivesWithoutAttribute({ commit }, { attributeId, page, perPage }) {
            return strategyService.getObjectivesWithoutAttribute(attributeId, page, perPage).then((resp) => {
                const { data, current_page, per_page, from, to, total } = resp
                commit('SET_OBJECTIVES', data)
                return {
                    data,
                    currentPage: current_page,
                    perPage: per_page,
                    from,
                    to,
                    total,
                }
            })
        },
        getObjectivesByAttribute({ commit }, { attributeId, page, perPage }) {
            return strategyService.getObjectivesByAttribute(attributeId, page, perPage).then((resp) => {
                const { data, current_page, per_page, from, to, total } = resp
                commit('SET_OBJECTIVES_LINKED', data)
                return {
                    data,
                    currentPage: current_page,
                    perPage: per_page,
                    from,
                    to,
                    total,
                }
            })
        },
        linkObjectives({ dispatch }, { attributeId, objectivesToLinkIDs }) {
            return dispatch('getObjectivesByAttribute', { attributeId }).then(({ data }) => {
                const linkedObjectivesIDs = data.map((o) => o.id)
                return strategyService.updateLinkedObjectives(attributeId, [
                    ...objectivesToLinkIDs,
                    ...linkedObjectivesIDs,
                ])
            })
        },
        unlinkObjectives({ dispatch }, { attributeId, objectivesToUnlinkIDs }) {
            return dispatch('getObjectivesByAttribute', { attributeId }).then(({ data }) => {
                const linkedObjectivesIDs = data.map((o) => o.id)
                objectivesToUnlinkIDs = objectivesToUnlinkIDs.map((o) => parseInt(o))
                const objectivesToKeepLinkedIDs = difference(linkedObjectivesIDs, objectivesToUnlinkIDs)
                return strategyService.updateLinkedObjectives(attributeId, objectivesToKeepLinkedIDs)
            })
        },
    },
}
